<template>
	<div v-loading="loading">
		<div class="alert-div">
			<i class="el-icon-circle-check"></i>
			已成功绑定微信账户,填写账户信息,确认绑定,即完成账户登陆!
		</div>
		<el-tabs stretch>
			<el-tab-pane label="绑定老账号">
				<div class="form-div">
					<el-form @keyup.enter.native="submitForm('loginForm')"
						:model="loginObj" :rules="loginFormRules" ref="loginForm">
						<el-form-item prop="username">
							<el-input v-model="loginObj.username" placeholder="账号"></el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input v-model="loginObj.password" placeholder="密码" show-password ></el-input>
						</el-form-item>
					</el-form>
					<div>
						<el-button @click="submitForm('loginForm')" type="primary" style="width: 100%;">登录</el-button>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="注册新账号">
				<div class="form-div">
					<el-form @keyup.enter.native="submitForm('registerForm')" :model="registerObj" :rules="registerFormRules" ref="registerForm">
						<el-form-item prop="username"><el-input v-model="registerObj.username" placeholder="手机号"></el-input></el-form-item>
						<el-form-item prop="password"><el-input v-model="registerObj.password" placeholder="密码" show-password></el-input></el-form-item>
						<el-form-item prop="passwordAgain"><el-input v-model="registerObj.passwordAgain" placeholder="再次输入密码" show-password></el-input></el-form-item>
						<el-form-item label="邀请码" prop="code" v-if="registerObj.invitationCode">
							<el-input disabled  v-model="registerObj.invitationCode" placeholder="邀请码"></el-input>
						</el-form-item>
					</el-form>
					<div>
						<el-button @click="submitForm('registerForm')" type="primary" style="width: 100%;">注册</el-button>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>

	<!--			<div v-if="!bindAccountObj.bandType" style="text-align: center;">-->
	<!--				<el-button style="height: 50px">绑定已有账号</el-button>-->
	<!--				<el-button style="height: 50px">绑定新账号</el-button>-->
	<!--			</div>-->
	</div>
</template>

<script>
import { api_login_public, api_register_public } from "@/components/api/sign";
import { setToken } from "@/components/common/utils/tokenAuth";

export default {
	name: "bandAccountWx",
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg','F_reload','F_LOGIN'],
	data(){
		let registerPass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'))
			} else if (value !== this.$data.registerObj.password) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}
		return {
			loading : false,
			loginFormRules : {
				username : [
					{ required: true, message: '用户名不能为空', trigger: 'blur' },
				],
				password : [
					{ required: true, message: '密码不能为空', trigger: 'blur' },
				],
			},
			registerFormRules: {
				username: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
				password: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
				passwordAgain: [{ validator: registerPass2 , required: true, trigger: 'blur' }],
			},
			loginObj :{
				username : '',
				password : '',
				code : ''
			},
			registerObj: {
				username: '',
				password: '',
				passwordAgain: '',
				invitationCode: localStorage.getItem('referrer')
			},
		}
	},
	props : {
		oauth2UserId : {
			required : true
		}
	},
	methods:{
		submitForm : function(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (formName === 'registerForm'){
						this.$options.methods.register(this)
					}else {
						this.$options.methods.login(this)
					}
				}
			});
		},
		login :function(this_){
			this_ = this_ || this
			let username = this_.$data.loginObj.username
			let password = this_.$data.loginObj.password
			// 显示遮罩层
			this_.$data.loading = true
			api_login_public(username,password,this_.oauth2UserId).then(res => {
				setToken(res.data.token)
				window.reSetUser(res.data.userInfo,true)
				this_.$router.push('/')
				// 关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg('登录成功',2)
			}).catch(err => {
				// 关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err,"登录失败"),4)
			})
		},
		register :function(this_){
			this_ = this_ || this
			if (this_.$data.loading){
				return
			}
			let username = this_.$data.registerObj.username
			let password = this_.$data.registerObj.password
			let invitationCode = this_.$data.registerObj.invitationCode
			this_.$data.loading = true
			api_register_public(username,password,invitationCode,this_.oauth2UserId).then(res => {
				setToken(res.data,true)
				this_.F_LOGIN()
				this_.$router.push('/')
				this_.$data.loading = false
				// 清除邀请码
				localStorage.removeItem('referrer')
				this_.F_alertMsg('注册成功',2)
			}).catch(err => {
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err,"注册失败"),4)
			})
		}
	}
}
</script>

<style scoped>
.form-div{
	margin-top: 15px;
}
.alert-div{
	padding: 8px 16px;
	background-color: #f0f9eb;
	color: #67C23A;
	border-radius: 4px;
	align-items: center;
	margin-bottom: 20px;
}
</style>